const t = {
  name: "GraphUp",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M22 2H15V4H18.586L10.0002 12.5858L6.00015 8.5858L1.58594 13L3.00015 14.4142L6.00015 11.4142L10.0002 15.4142L20 5.41438V9H22V2Z" fill="currentColor"/>
<path d="M7 22H5V15H7V22Z" fill="currentColor"/>
<path d="M11 18V22H9V18H11Z" fill="currentColor"/>
<path d="M15 22V16H13V22H15Z" fill="currentColor"/>
<path d="M19 11V22H17L17 11H19Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as GraphUp
};
